const schedulesPageMapping: { [key: string]: PageMapping } = {
	"/produce/production/schedule": {
		nav: true,
		title: "Production Schedule",
		titleKey: "nav.produce.schedule.production.title",
		description: "View and manage production lots and jobs",
		descriptionKey: "nav.produce.schedule.production.description",
		label: "Production",
		labelKey: "nav.produce.schedule.production.label",
		buttons: [],
		actions: []
	},
	"/produce/production/schedule/jobs/.+": {
		nav: false,
		title: "Production Schedule",
		titleKey: "nav.produce.schedule.production.title",
		description: "View and manage production lots and jobs",
		descriptionKey: "nav.produce.schedule.production.description",
		label: "Production",
		labelKey: "nav.produce.schedule.production.label",
		buttons: [],
		actions: []
	},
	"/produce/production/schedule/events": {
		nav: true,
		title: "Event Schedule",
		titleKey: "nav.produce.schedule.events.title",
		description: "View all scheduled events across production jobs with inline edits",
		descriptionKey: "nav.produce.schedule.events.description",
		label: "Event Schedule",
		labelKey: "nav.produce.schedule.events.label",
		buttons: [],
		actions: []
	},
	"/produce/production/plan-builder": {
		nav: false,
		title: "Plan Builder",
		titleKey: "nav.produce.schedule.planBuilder.title",
		description: "Plan weekly production quantities for each item across the year",
		descriptionKey: "nav.produce.schedule.planBuilder.description",
		label: "Plan Builder",
		labelKey: "nav.produce.schedule.planBuilder.label",
		buttons: [],
		actions: []
	},
	"/produce/production/schedule/import": {
		nav: false,
		title: "Schedule Import",
		titleKey: "nav.produce.schedule.import.title",
		description: "Import production schedules from CSV",
		descriptionKey: "nav.produce.schedule.import.description",
		label: "Import",
		labelKey: "nav.produce.schedule.import.label",
		buttons: [],
		actions: []
	},
	"/produce/production/schedule/import/new": {
		nav: false,
		title: "",
		description: "",
		label: "New Import",
		labelKey: "nav.produce.schedule.importNew.label",
		buttons: [],
		actions: []
	},
	"/produce/production/schedule/import/.+": {
		nav: false,
		title: "",
		description: "",
		label: "Import Job",
		labelKey: "nav.produce.schedule.importJob.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/produce/space-planning": {
		nav: true,
		title: "Space Plan",
		titleKey: "nav.produce.schedule.spacePlan.title",
		description: "Visualize greenhouse space usage across facilities and time periods",
		descriptionKey: "nav.produce.schedule.spacePlan.description",
		label: "Space",
		labelKey: "nav.produce.schedule.spacePlan.label",
		buttons: [],
		actions: []
	}
};

const laborPageMapping: { [key: string]: PageMapping } = {
	"/produce/labor/schedule": {
		nav: true,
		title: "Labor Schedule",
		titleKey: "nav.produce.labor.schedule.title",
		description: "View planned labor demand by date, task type, and block",
		descriptionKey: "nav.produce.labor.schedule.description",
		label: "Schedule",
		labelKey: "nav.produce.labor.schedule.label",
		buttons: [],
		actions: []
	},
	"/produce/labor/crew": {
		nav: true,
		title: "Crew View",
		titleKey: "nav.produce.labor.crew.title",
		description: "Live crew status, hours, and task distribution",
		descriptionKey: "nav.produce.labor.crew.description",
		label: "Crew",
		labelKey: "nav.produce.labor.crew.label",
		buttons: [],
		actions: []
	},
	"/produce/labor/rates": {
		nav: true,
		title: "Labor Rates",
		titleKey: "nav.produce.labor.rates.title",
		description: "Manage labor types and hourly rates by site location",
		descriptionKey: "nav.produce.labor.rates.description",
		label: "Rates",
		labelKey: "nav.produce.labor.rates.label",
		buttons: [],
		actions: []
	},
	"/produce/labor/tasks": {
		nav: true,
		title: "Task Admin",
		titleKey: "nav.produce.labor.tasks.title",
		description: "Create, edit, and reassign worker tasks",
		descriptionKey: "nav.produce.labor.tasks.description",
		label: "Tasks",
		labelKey: "nav.produce.labor.tasks.label",
		buttons: [],
		actions: []
	}
};

const flattenPageMapping = (mapping: { [key: string]: PageMapping }): { [key: string]: PageMapping } => {
	const out: { [key: string]: PageMapping } = {};
	Object.entries(mapping).forEach(([key, value]) => {
		out[key] = value;
		if (value.children) Object.assign(out, flattenPageMapping(value.children));
	});
	return out;
};

const maintenancePageMapping: { [key: string]: PageMapping } = {
	"/produce/production/recipes": {
		nav: true,
		title: "Recipes",
		titleKey: "nav.produce.maintenance.recipes.title",
		description: "Manage crop recipes and growing specifications",
		descriptionKey: "nav.produce.maintenance.recipes.description",
		label: "Recipes",
		labelKey: "nav.produce.maintenance.recipes.label",
		buttons: [],
		actions: []
	},
	"/produce/production/recipes/link-health": {
		nav: true,
		title: "Recipe Link Health",
		titleKey: "nav.produce.maintenance.linkHealth.title",
		description: "Find recipe links that will fail a lot build and fix them before they do",
		descriptionKey: "nav.produce.maintenance.linkHealth.description",
		label: "Link Health",
		labelKey: "nav.produce.maintenance.linkHealth.label",
		buttons: [],
		actions: []
	},
	"/produce/production/items": {
		nav: true,
		title: "Production Items",
		titleKey: "nav.produce.maintenance.productionItems.title",
		description: "Manage catalogs, categories, and production items",
		descriptionKey: "nav.produce.maintenance.productionItems.description",
		label: "Production Items",
		labelKey: "nav.produce.maintenance.productionItems.label",
		buttons: [],
		actions: [],
		children: {
			"/produce/production/items/catalogs": {
				nav: true,
				title: "",
				description: "",
				label: "Catalogs",
				labelKey: "nav.produce.maintenance.catalogs.label",
				buttons: [],
				actions: []
			},
			"/produce/production/items/catalogs/.+": {
				nav: false,
				title: "",
				description: "",
				label: "Catalog",
				labelKey: "nav.produce.maintenance.catalog.label",
				buttons: [],
				actions: [],
				identifier: true
			},
			"/produce/production/items/categories": {
				nav: true,
				title: "",
				description: "",
				label: "Categories",
				labelKey: "nav.produce.maintenance.categories.label",
				buttons: [],
				actions: []
			},
			"/produce/production/items/categories/.+": {
				nav: false,
				title: "",
				description: "",
				label: "Category",
				labelKey: "nav.produce.maintenance.category.label",
				buttons: [],
				actions: [],
				identifier: true
			},
			"/produce/production/items/production-items": {
				nav: true,
				title: "",
				description: "",
				label: "Production Items",
				labelKey: "nav.produce.maintenance.productionItemsList.label",
				buttons: [],
				actions: []
			},
			"/produce/production/items/production-items/.+": {
				nav: false,
				title: "",
				description: "",
				label: "Production Item",
				labelKey: "nav.produce.maintenance.productionItem.label",
				buttons: [],
				actions: [],
				identifier: true
			}
		}
	},
	"/produce/production/material-items": {
		nav: true,
		title: "Material Items",
		titleKey: "nav.produce.maintenance.materialItems.title",
		description: "Manage material items and vendor assignments",
		descriptionKey: "nav.produce.maintenance.materialItems.description",
		label: "Material Items",
		labelKey: "nav.produce.maintenance.materialItems.label",
		buttons: [],
		actions: []
	},
	"/produce/maintenance/events": {
		nav: true,
		title: "Events",
		titleKey: "nav.produce.maintenance.eventsSection.title",
		label: "Events",
		labelKey: "nav.produce.maintenance.eventsSection.label",
		buttons: [],
		actions: [],
		children: {
			"/produce/production/events": {
				nav: true,
				title: "Events",
				titleKey: "nav.produce.maintenance.events.title",
				description: "Manage produce events",
				descriptionKey: "nav.produce.maintenance.events.description",
				label: "Events",
				labelKey: "nav.produce.maintenance.events.label",
				buttons: [],
				actions: []
			},
			"/produce/production/events/import": {
				nav: false,
				title: "Import Space Events",
				titleKey: "nav.produce.maintenance.eventsImport.title",
				description: "Import space events from CSV",
				descriptionKey: "nav.produce.maintenance.eventsImport.description",
				label: "Import Space Events",
				labelKey: "nav.produce.maintenance.eventsImport.label",
				buttons: [],
				actions: []
			},
			"/produce/production/triggers": {
				nav: true,
				title: "Triggers",
				titleKey: "nav.produce.maintenance.triggers.title",
				description: "Manage triggers used in events",
				descriptionKey: "nav.produce.maintenance.triggers.description",
				label: "Triggers",
				labelKey: "nav.produce.maintenance.triggers.label",
				buttons: [],
				actions: []
			}
		}
	},
	"/produce/maintenance/space-planning": {
		nav: true,
		title: "Space Planning",
		titleKey: "nav.produce.maintenance.spacePlanningSection.title",
		label: "Space Planning",
		labelKey: "nav.produce.maintenance.spacePlanningSection.label",
		buttons: [],
		actions: [],
		children: {
			"/produce/capacity/categories-and-types": {
				nav: true,
				title: "Categories & Types",
				titleKey: "nav.produce.maintenance.categoriesAndTypes.title",
				description: "Manage space categories and types",
				descriptionKey: "nav.produce.maintenance.categoriesAndTypes.description",
				label: "Categories & Types",
				labelKey: "nav.produce.maintenance.categoriesAndTypes.label",
				buttons: [],
				actions: []
			},
			"/produce/capacity/locations": {
				nav: true,
				title: "Locations",
				titleKey: "nav.produce.maintenance.locations.title",
				description: "Manage site locations and sub-location capacity",
				descriptionKey: "nav.produce.maintenance.locations.description",
				label: "Locations",
				labelKey: "nav.produce.maintenance.locations.label",
				buttons: [],
				actions: []
			}
		}
	},
	"/produce/maintenance/costing": {
		nav: true,
		title: "Costing",
		titleKey: "nav.produce.maintenance.costingSection.title",
		label: "Costing",
		labelKey: "nav.produce.maintenance.costingSection.label",
		buttons: [],
		actions: [],
		children: {
			"/produce/capacity/overhead-rates": {
				nav: true,
				title: "Overhead Rates",
				titleKey: "nav.produce.maintenance.overheadRates.title",
				description: "Manage overhead cost rates per square foot by site location",
				descriptionKey: "nav.produce.maintenance.overheadRates.description",
				label: "Overhead Rates",
				labelKey: "nav.produce.maintenance.overheadRates.label",
				buttons: [],
				actions: []
			},
			"/produce/purchasing/vendors": {
				nav: true,
				title: "Vendors",
				titleKey: "nav.produce.maintenance.vendors.title",
				description: "View and manage vendor information and material assignments",
				descriptionKey: "nav.produce.maintenance.vendors.description",
				label: "Vendors",
				labelKey: "nav.produce.maintenance.vendors.label",
				buttons: [],
				actions: []
			}
		}
	}
};

const purchasingPageMapping: { [key: string]: PageMapping } = {
	"/produce/purchasing/orders": {
		nav: true,
		title: "Purchase Orders",
		titleKey: "nav.produce.purchasing.orders.title",
		description: "View and manage vendor purchase orders",
		descriptionKey: "nav.produce.purchasing.orders.description",
		label: "Orders",
		labelKey: "nav.produce.purchasing.orders.label",
		buttons: [],
		actions: []
	},
	"/produce/purchasing/spend": {
		nav: true,
		title: "Vendor Spend",
		titleKey: "nav.produce.purchasing.spend.title",
		description: "View cost analysis and vendor spending",
		descriptionKey: "nav.produce.purchasing.spend.description",
		label: "Spend",
		labelKey: "nav.produce.purchasing.spend.label",
		buttons: [],
		actions: []
	}
};

const hardgoodInventoryPageMapping: { [key: string]: PageMapping } = {
	"/produce/inventory/hardgoods": {
		nav: true,
		title: "Hard Goods Inventory",
		titleKey: "nav.produce.hardgoods.list.title",
		description: "On-hand vs recipe-required hardgoods by item and bin, with cycle-count status",
		descriptionKey: "nav.produce.hardgoods.list.description",
		label: "Hard Goods",
		labelKey: "nav.produce.hardgoods.list.label",
		buttons: [],
		actions: []
	}
};

const dataTransformPageMapping: { [key: string]: PageMapping } = {
	"/produce/data-transform": {
		nav: true,
		title: "Data Transform",
		titleKey: "nav.produce.dataTransform.page.title",
		description: "Convert Agroware Arc Flow exports into PRODUCE import files",
		descriptionKey: "nav.produce.dataTransform.page.description",
		label: "Data Transform",
		labelKey: "nav.produce.dataTransform.page.label",
		buttons: [],
		actions: []
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	"/produce": {
		nav: false,
		title: "",
		label: "Produce",
		labelKey: "nav.produce.sections.produce.label",
		icon: "agriculture",
		buttons: [],
		actions: []
	},
	"/produce/schedules": {
		nav: false,
		title: "Schedules",
		titleKey: "nav.produce.sections.schedules.title",
		label: "Schedules",
		labelKey: "nav.produce.sections.schedules.label",
		icon: "calendar_month",
		buttons: [],
		actions: [],
		children: schedulesPageMapping
	},
	"/produce/labor": {
		nav: false,
		title: "Labor",
		titleKey: "nav.produce.sections.labor.title",
		label: "Labor",
		labelKey: "nav.produce.sections.labor.label",
		icon: "groups",
		buttons: [],
		actions: [],
		children: laborPageMapping
	},
	"/produce/purchasing": {
		nav: false,
		title: "Purchasing",
		titleKey: "nav.produce.sections.purchasing.title",
		label: "Purchasing",
		labelKey: "nav.produce.sections.purchasing.label",
		icon: "shopping_cart",
		buttons: [],
		actions: [],
		children: purchasingPageMapping
	},
	"/produce/hardgood-inventory": {
		nav: false,
		title: "Hardgood Inventory",
		titleKey: "nav.produce.sections.hardgoodInventory.title",
		label: "Hardgood Inventory",
		labelKey: "nav.produce.sections.hardgoodInventory.label",
		icon: "inventory_2",
		buttons: [],
		actions: [],
		children: hardgoodInventoryPageMapping
	},
	"/produce/settings": {
		nav: true,
		title: "Settings",
		titleKey: "nav.produce.settings.title",
		description: "Tenant-level production defaults",
		descriptionKey: "nav.produce.settings.description",
		label: "Settings",
		labelKey: "nav.produce.settings.label",
		buttons: [],
		actions: []
	},
	"/produce/maintenance": {
		nav: false,
		title: "Maintenance",
		titleKey: "nav.produce.sections.maintenance.title",
		label: "Maintenance",
		labelKey: "nav.produce.sections.maintenance.label",
		icon: "tune",
		buttons: [],
		actions: [],
		children: maintenancePageMapping
	},
	"/produce/data-transform": {
		nav: false,
		title: "Data Transform",
		titleKey: "nav.produce.sections.dataTransform.title",
		label: "Data Transform",
		labelKey: "nav.produce.sections.dataTransform.label",
		icon: "sync_alt",
		buttons: [],
		actions: [],
		children: dataTransformPageMapping
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...flattenPageMapping(schedulesPageMapping),
	...flattenPageMapping(laborPageMapping),
	...flattenPageMapping(maintenancePageMapping),
	...purchasingPageMapping,
	...hardgoodInventoryPageMapping,
	...dataTransformPageMapping
};
